import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Aldieri L., Carlucci F., Vinci C.P. and Yigitcanlar T. (2019).
              Environmental innovation, knowledge spillovers and policy
              implications: A systematic review of the economic effects
              literature. <em>J Clean Prod </em>
              <strong>239</strong>:118051
            </p>
            <p>
              Andronache I., Marin M., Fischer R., Ahammer H., Radulovic M.,
              Ciobotaru A.M., Jelinek H.F., Di Ieva A., Pintilii R.D., Drăghici
              C.C., Herman G.V., Nicula A.S., Simion A.G., Loghin I.V., Diaconu
              D.C. and Peptenatu D. (2019). Dynamics of Forest Fragmentation and
              Connectivity Using Particle and Fractal Analysis. <em>Sci Rep</em>
              . <strong>9</strong>(1):12228.
              https://doi.org/10.1038/s41598-019-48277-z.
            </p>
            <p>
              Banerjee A. and Madhurima C. (2013). Forest degradation and
              livelihood of local communities in India: A human rights approach.{" "}
              <em>J Hortic For</em>
              <strong> 5</strong>:122&ndash;129
            </p>
            <p>
              Beinat E. (1997). Value functions for environmental management.
              In: Value Functions for Environmental Management. Springer
              Netherlands, Dordrecht, pp 77&ndash;106
            </p>
            <p>
              Bell C.W., Tissue D.T., Loik M.E., Wallenstein M.D.,
              Acosta-Martinez V., Erickson R.A. and Zak J.C. (2014). Soil
              microbial and nutrient responses to 7&nbsp;years of seasonally
              altered precipitation in a Chihuahuan Desert grassland.{" "}
              <em>Glob Chang Biol</em>. <strong>20</strong>(5):1657-73.
              https://doi.org/10.1111/gcb.12418.
            </p>
            <p>
              Bharath S., Rajan K.S. and Ramachandra T.V. (2013). Land Surface
              Temperature Responses to Land Use Land Cover Dynamics.{" "}
              <em>Geoinfor GeostatAn Overv</em>
              <strong> 1</strong>:20-24.
              https://doi.org/10.4172/2327-4581.1000112
            </p>
            <p>
              Bharath S., Rajan K.S., Ramachandra T.V. (2021) Modeling Forest
              Landscape Dynamics, Environmen. Nova Science Publishers, New York,
              NY (United States)
            </p>
            <p>
              Bharath S. and Ramachandra T.V. (2021). Modeling Landscape
              Dynamics of Policy Interventions in Karnataka State, India.{" "}
              <em>J Geovisualization Spat Anal </em>
              <strong>5</strong>:1&ndash;23
            </p>
            <p>
              Brinck K., Fischer R., Groeneveld J., Lehmann S., Dantas De Paula
              M., P&uuml;tz S., Sexton J.O., Song D. and Huth A. (2017). High
              resolution analysis of tropical forest fragmentation and its
              impact on the global carbon cycle. Nat Commun. 17(8):14855.
              https://doi.org/10.1038/ncomms14855.
            </p>
            <p>
              Champion H.G. and Seth S.K. (1968). A revised survey of the forest
              types of India. Manager of publications, the University of
              Minnesotta, Pp 404
            </p>
            <p>
              Chaplin-Kramer R., Ramler I., Sharp R., Haddad N.M., Gerber J.S.,
              West P.C., Mandle L., Engstorm P., Baccini A., Sim S., Mueller C.
              and King H. (2015). Degradation in carbon stocks near tropical
              forest edges. <em>Nat Commun</em> <strong>6</strong>: 10158.
              https://doi.org/10.1038/ncomms10158
            </p>
            <p>
              ESMAP (2020). Energy Sector Management Assistance Program Annual
              Report 2020 (English). Washington, D.C.
            </p>
            <p>
              Ewers RM. and Banks-Leite C. (2013). Fragmentation impairs the
              microclimate buffering effect of tropical forests.{" "}
              <em>PLoS One </em>
              <strong>8</strong>:e58093
            </p>
            <p>
              Gadgil M., Daniels R.J.R., Ganeshaiah K.N., Prsad S.N., Murthy
              M.S.R., Jha C.S., Ramesh B.R., Subramanian K.A. (2011). Mapping
              ecologically sensitive, significant and salient areas of Western
              Ghats: proposed protocols and methodology. <em>Curr Sci </em>
              <strong>100</strong> (2): 175&ndash;182
            </p>
            <p>
              Hunter M.O., Keller M. and Morton D. (2015). Structural dynamics
              of tropical moist forest gaps. <em>PLoS One </em>
              <strong>10</strong>:e0132144
            </p>
            <p>
              Karthik R., Robin R.S. and Anandavelu I. (2020). Diatom bloom in
              the Amba River, west coast of India: a nutrient-enriched tropical
              river-fed estuary. <em>Reg Stud Mar Sci </em>
              <strong>35</strong>:101244
            </p>
            <p>
              Koschke L., F&uuml;rst C., Frank S. and Makeschin F. (2012). A
              multi-criteria approach for an integrated land-cover-based
              assessment of ecosystem services provision to support landscape
              planning. <em>Ecol Indic </em>
              <strong>21</strong>:54&ndash;66
            </p>
            <p>
              Ku&egrave;as A., Trakimas G., Bal&egrave;iauskas L. and Vaitkus G.
              (2011). Multi-scale analysis of forest fragmentation in Lithuania.{" "}
              <em>Balt For </em>
              <strong>17</strong>:128&ndash;135
            </p>
            <p>
              Kumar M.A., Mudappa D. and Raman T.R.S. (2010). Asian elephant
              Elephas maximus habitat use and ranging in fragmented rainforest
              and plantations in the Anamalai Hills, India.{" "}
              <em>Trop Conserv Sci </em>
              <strong>3</strong>:143&ndash;158
            </p>
            <p>
              Langlois L.A., Drohan P.J. and Brittingham M.C. (2017). Linear
              infrastructure drives habitat conversion and forest fragmentation
              associated with Marcellus shale gas development in a forested
              landscape.<em> J Environ Manage </em>
              <strong>197</strong>:167&ndash;176
            </p>
            <p>
              Latimer C.E and Zuckerberg B. (2017). Forest fragmentation alters
              winter microclimates and microrefugia in human-modified
              landscapes. <em>Ecography (Cop)</em>
              <strong>40</strong>:158&ndash;170
            </p>
            <p>
              Leman N., Ramli M.F. and Khirotdin R.P.K. (2016). GIS-based
              integrated evaluation of environmentally sensitive areas (ESAs)
              for land use planning in Langkawi, Malaysia. <em>Ecol Indic </em>
              <strong>61</strong>:293&ndash;308
            </p>
            <p>
              Lillesand T.M., Kiefer R.W. and Chipman J.W. (2014). Remote
              sensing and image interpretation, 7<sup>th</sup>edn. Wiley
              Publishers, Newyork
            </p>
            <p>
              Liu J., Gao J. and Ma S. (2015). Comprehensive evaluation of
              eco-environmental sensitivity in Inner Mongolia, China.{" "}
              <em>China Environ Sci </em>
              <strong>35</strong>:591&ndash;598
            </p>
            <p>
              Misra A.K., Lata K. and Shukla J.B. (2014). Effects of population
              and population pressure on forest resources and their
              conservation: a modeling study. <em>Environ Dev Sustain </em>
              <strong>16</strong>:361&ndash;374
            </p>
            <p>
              MOEF (2000). Report of the Committee on Identifying Parameters for
              Designating Ecologically Sensitive Areas in India (Pronab Sen
              Committee Report). The Ministry of Environment, Forestsa and
              Climate Change, Government of India, New Delhi
            </p>
            <p>
              Mote S., Rivas J. and Kalnay E. (2020). A novel approach to
              carrying capacity: from a priori prescription to a posteriori
              derivation based on underlying mechanisms and dynamics.{" "}
              <em>Annu Rev Earth Planet Sci </em>
              <strong>48</strong>:657&ndash;683
            </p>
            <p>
              Myers N., Mittermeier R.A., Mittermeier C.G., da Fonseca G.A. and
              Kent J. (2000). Biodiversity hotspots for conservation priorities.{" "}
              <em>Nature </em>
              <strong>403</strong>:853&ndash;858
            </p>
            <p>
              Nakhawa A., Priyanka V.S. and Markad S. (2017). Mangrove mapping
              of different estuaries along Ratnagiri block using remote sensing.{" "}
              <em>Ecol Environ Conserv </em>
              <strong>23</strong>:819&ndash;824
            </p>
            <p>
              Nayak B.P., Kohli P. and Sharma J. V. (2012). Livelihood of local
              communities and forest degradation in India: Issues for REDD+.
              Minist Environ For Gov India New Delhi India Web http//envfor nic
              in/assets/redd-bk3 pdf Accessed 18 October 2021
            </p>
            <p>
              Nayak R., Karanth K.K., Dutta T., <em>Karanth </em>K.U. and
              Vaidyanathan S. (2020). Bits and pieces: Forest fragmentation by
              linear intrusions in India.<em> Land use policy</em>
              <strong>99</strong>:104619
            </p>
            <p>
              Olson D.M., Dinerstein E. and Wikramanayake E.D. (2001).
              Terrestrial Ecoregions of the World: A New Map of Life on EarthA
              new global map of terrestrial ecoregions provides an innovative
              tool for conserving biodiversity. <em>Bioscience</em>
              <strong>51</strong>:933&ndash;938
            </p>
            <p>
              Otukei J.R. and &nbsp;Blaschke T. (2010). Land cover change
              assessment using decision trees, support vector machines and
              maximum likelihood classification algorithm
              <em>s. Int J Appl Earth Obs Geoinf </em>
              <strong>12</strong>:S27--S31
            </p>
            <p>
              Pascal J.P. (1986). Explanatory Booklet on Forest Map of South
              India. Explan Bookl For Map South India Belgaum-Dharwar-Panaji ,
              Shimoga, Mercara-Mysore 19&ndash;30,
              https://www.ifpindia.org/bookstore/hs18/
            </p>
            <p>
              Peters D.P.C., Yao J., Sala O.E. and Anderson J.P. (2012).
              Directional climate change and potential reversal of
              desertification in arid and semiarid ecosystems.{" "}
              <em>Glob Chang Biol </em>
              <strong>18</strong>:151&ndash;163
            </p>
            <p>
              Ramachandra T.V., Bharath S. and Vinay S. (2019a). Visualisation
              of impacts due to the proposed developmental projects in the
              ecologically fragile regions- Kodagu district, Karnataka. Prog{" "}
              <em>Disaster Sci </em>
              <strong>3</strong>:100038.
              https://doi.org/10.1016/j.pdisas.2019.100038
            </p>
            <p>
              Ramachandra T.V., Bharath S., Vinay S. (2019b). Grid Based
              Monitoring of Natural Resources in the Ecologically Fragile
              Regions of Kodagu, Karnataka, ENVIS Technical Report 156, Sahyadri
              Conservation Series 83. Indian Institute of Science. Bangalore, Pp
              152
            </p>
            <p>
              Ramachandra T.V., Bharath S., and Vinay S. (2021). Landslides in
              Western Ghats &amp; Coastal area-Causes, Triggers, and Solutions.
              Bull Dep For Environ Ecol Gov Karnataka, 25&ndash;45
            </p>
            <p>
              Ramachandra T.V., Raj R., and Bharath H.A. (2019c). Valuation of
              Aghanashini estuarine ecosystem goods and services.{" "}
              <em>J Biodivers </em>
              <strong>10</strong>:45&ndash;58
            </p>
            <p>
              Ramachandra T.V., Rishab J., Krishnadas G., and Bharath S.
              (2016a). Hotspots of Solar Potential in India. In: LAKE 2016:
              Conference on Conservation and Sustainable Management of
              Ecologically Sensitive Regions in Western Ghats. EWRG, CES, IISc,
              Bangalore, Moodabidri, Karnataka, India
            </p>
            <p>
              Ramachandra T.V. and Bharath S. (2021). Carbon Footprint of
              Karnataka: Accounting of Sources and Sinks. In: Carbon Footprint
              Case Studies. Springer, pp 53&ndash;92
            </p>
            <p>
              Ramachandra T.V. and Bharath S. (2019a). Carbon Sequestration
              Potential of the Forest Ecosystems in the Western Ghats, a Global
              Biodiversity Hotspot. <em>Nat Resour Res </em>
              <strong>29</strong>:2753&ndash;2771.
              https://doi.org/10.1007/s11053-019-09588-0
            </p>
            <p>
              Ramachandra T.V. and Bharath S. (2019b) Global Warming Mitigation
              Through Carbon Sequestrations in the Central Western Ghats.{" "}
              <em>Remote Sens Earth SystSci </em>
              <strong>2</strong>:39&ndash;63.
              https://doi.org/10.1007/s41976-019-0010-z
            </p>
            <p>
              Ramachandra T.V., Bharath S., and Bharath H.A. (2020a). Insights
              of Forest Dynamics for the Regional Ecological Fragility
              Assessment. <em>J Indian Soc Remote Sens </em>
              <strong>48</strong>:1169&ndash;1189.
              https://doi.org/10.1007/s12524-020-01146-z
            </p>
            <p>
              Ramachandra T.V., Bharath S., Chandran M.D.S. and Joshi N. V.
              (2018a). Salient Ecological Sensitive Regions of Central Western
              Ghats, India. Earth Syst Environ <strong>2</strong>:15&ndash;34
            </p>
            <p>
              Ramachandra T.V., Bharath S., and Chandran M.D.S. (2016b).
              Geospatial analysis of forest fragmentation in Uttara Kannada
              District, India. <em>For Ecosyst</em>
              <strong> 3</strong>:10. https://doi.org/10.1186/s40663-016-0069-4
            </p>
            <p>
              Ramachandra T.V., Bharath S. and Gupta N. (2018b). Modelling
              landscape dynamics with LST in protected areas of Western Ghats,
              Karnataka. <em>J. Environ. Manage</em>. <strong>206</strong>
              :1253-1262. doi: 10.1016/j.jenvman.2017.08.001
            </p>
            <p>
              Ramachandra T.V., Bharath S., Rajan K.S. and Chandran M.D.S.
              (2017a). Modelling the forest transition in Central Western Ghats,
              India. <em>Spat Inf Res</em>
              <strong>25</strong>:117&ndash;130.
              https://doi.org/10.1007/s41324-017-0084-8
            </p>
            <p>
              Ramachandra T.V., Bharath S., Rajan K.S. and Chandran M.D.S.
              (2016c). Stimulus of developmental projects to landscape dynamics
              in Uttara Kannada, Central Western Ghats.{" "}
              <em>Egypt J Remote Sens</em> Sp Sci <strong>19</strong>:.
              https://doi.org/10.1016/j.ejrs.2016.09.001
            </p>
            <p>
              Ramachandra T.V., Bharath S. and Vinay S. (2018c). Ecological
              Sustainability of Riverine Ecosystems in Central Western Ghats.{" "}
              <em>J Biodivers </em>
              <strong>9</strong>:25&ndash;42
            </p>
            <p>
              Ramachandra T.V., Hegde G., Setturu B., and Krishnadas G. (2014).
              Bioenergy: A sustainable energy option for rural India.{" "}
              <em>Adv For Lett </em>
              <strong>3</strong>:1&ndash;15
            </p>
            <p>
              Ramachandra T.V., Vinay S., Bharath S., and Bharath H.A. (2020b).
              Insights into riverscape dynamics with the hydrological,
              ecological and social dimensions for water sustenance.{" "}
              <em>Curr Sci </em>
              <strong>118</strong>:1379&ndash;1393
            </p>
            <p>
              Ramachandra T.V. and Bharath S. (2019c). Sustainable Management of
              Bannerghatta National Park, India, with the Insights in Land Cover
              Dynamics. <em>FIIB Bus Rev </em>
              <strong>8</strong>:118&ndash;131.
              https://doi.org/10.1177/2319714519828462
            </p>
            <p>
              Ramachandra T.V. and Bharath S. (2018) Geoinformatics based
              Valuation of Forest Landscape Dynamics in Central Western Ghats,
              India. <em>J Remote Sens GIS</em>
              <strong> 07</strong>:1&ndash;8.
              https://doi.org/10.4172/2469-4134.1000227
            </p>
            <p>
              Ramachandra T.V, Tara N.M. and Bharath S. (2017b). Web based
              spatial decision support system for sustenance of western ghats
              biodiversity, ecology and hydrology. Creat Congition Art Des Ed by
              Aneesha Sharma Jamuna Rajeswaran 58&ndash;70
            </p>
            <p>
              Riitters K.H., Wickham J.D., O&rsquo;neill R.V., Jones K.B. and
              Smith E.R. (2002). Fragmentation of continental United States
              forests. <em>Ecosystems </em>
              <strong>5</strong>:815&ndash;822
            </p>
            <p>
              <span>
                Rohini C.K., Aravindan T. and Vinayan P.A. (2016). An assessment
                of human-elephant conflict and associated ecological and
                demographic factors in Nilambur, Western Ghats of Kerala,
                southern India. <em>J Threat taxa </em>
                <strong>8</strong>:8970&ndash;8976
              </span>
            </p>
            <p>
              <span>
                Sheil D. and Murdiyarso D. (2009). How forests attract rain: an
                examination of a new hypothesis. <em>Bioscience </em>
                <strong>59</strong>:341&ndash;347
              </span>
            </p>
            <p>
              <span>
                Spracklen D.V., Arnold S.R. and Taylor C.M. &nbsp;(2012).
                Observations of increased tropical rainfall preceded by air
                passage over forests. <em>Nature </em>
                <strong>489</strong>:282&ndash;285
              </span>
            </p>
            <p>
              <span>
                Sukumar R. (2006). A brief review of the status, distribution
                and biology of wild Asian elephants Elephas maximus.{" "}
                <em>Int Zoo Yearb </em>
                <strong>40</strong>:1&ndash;8
              </span>
            </p>
            <p>
              Termorshuizen J.W. and Opdam P. (2009). Landscape services as a
              bridge between landscape ecology and sustainable development.{" "}
              <em>Landsc Ecol </em>
              <strong>24</strong>:1037&ndash;1052
            </p>
            <p>
              United Nations (2015). Transforming our world: The 2030 agenda for
              sustainable development. New York United Nations, Dep Econ Soc Aff
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
